import tableRelatedLiveSportroomContent from './tableRelatedLiveSportroomContent';
import tableRelatedVodSportroomContent from './tableRelatedVodSportroomContent';

export default {
  title: 'VOD Contents',
  attributeName: 'vodContents',
  getURL: 'userVodSportroomContents',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: [],
  tableConfig: tableRelatedVodSportroomContent,
};
